import { Component, EventEmitter, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Product } from 'src/typings';

import { ProductService } from '../product.service';

@Component({
  selector: 'app-name-update',
  templateUrl: './name-update.component.html',
  styleUrls: ['./name-update.component.scss']
})
export class NameUpdateComponent {
  @Input() set product(product: Product | undefined) {
    this._product = product;
    this.descriptionControl.setValue(this.product?.description);
  }

  get product() {
    return this._product;
  }

  private _product: Product | undefined;

  descriptionControl = new UntypedFormControl();

  doneEvent: EventEmitter<Product> = new EventEmitter();

  constructor(private productService: ProductService) {}

  updateDescription() {
    if (!this.product) return;
    this.productService
      .updateProduct({
        id: this.product.id,
        description: this.descriptionControl.value
      })
      .subscribe((data) => {
        this.doneEvent.emit(data);
      });
  }
}
